import React, { Component } from 'react';
import styled from 'styled-components';
import ButtonText from 'components/ButtonText';
import H4 from 'components/H4';
import H5 from 'components/H5';
import AlertConfirm from 'components/AlertConfirm';
import PropTypes from 'prop-types';
import SettingsSectionTitle from './SettingsSectionTitle';

const Container = styled.div`
  margin: 0;
`;

const ButtonContainer = styled.div`
  margin-top: 25px;
  margin-bottom: 25px;
  float: left;
  @media (max-width: 767px) {
    float: none;
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
export default class CloseAccountView extends Component {
  state = {
    isOpenAlert: false,
  };

  closeAccount = () => {
    const { deleteAccount } = this.props;
    deleteAccount();
  };

  switchAlert = () => {
    const { isOpenAlert } = this.state;

    this.setState({ isOpenAlert: !isOpenAlert });
  };

  render() {
    const { isOpenAlert } = this.state;

    return (
      <Container>
        <SettingsSectionTitle>Delete account</SettingsSectionTitle>
        <Row>
          <ButtonContainer>
            <ButtonText text="Close account" theme="danger" onClick={() => this.switchAlert()} />
          </ButtonContainer>
        </Row>
        <AlertConfirm
          title="Close Account"
          onCancel={this.switchAlert}
          onSuccess={this.closeAccount}
          successText="Close"
          isVisible={isOpenAlert}
        >
          <H4 style={{ textAlign: 'center' }}>Are you sure that can close your account?</H4>
          <H5 style={{ textAlign: 'center' }}>
            Once you close the account, there is no going back. Please be certain.
          </H5>
        </AlertConfirm>
      </Container>
    );
  }
}

CloseAccountView.propTypes = {
  deleteAccount: PropTypes.func.isRequired,
};
